
import { defineComponent, ref, onMounted, getCurrentInstance } from 'vue';
import { RenderAccountType } from "@/types/RenderAccountType";
import {Vue} from "vue-class-component";

export { RenderAccountType };

export default class App extends Vue {
  isCEF = window.localStorage.getItem("isCEF") || false;
  isLauncher = window.localStorage.getItem("isLauncher") || false;
  instance = getCurrentInstance();

  getComponentKey(route: any): string {
    // Use same key for Home and Ticket View routes (same component, different props)
    if (route.name === 'Home' || route.name === 'Ticket View') {
      return 'HomeView';
    }
    // Use route path for workspace routes to ensure proper mounting
    // This ensures each workspace route gets a unique key
    if (route.path && route.path.startsWith('/workspace')) {
      return route.path;
    }
    // Default: use route name or path
    return route.name || route.path;
  }

  async mounted() {
    document.title = this.$t("main_title") as string;
    const bodyContainer = document.getElementsByClassName("body-container");
    const bodyElement = bodyContainer[0] as HTMLElement;
    if (this.isCEF) {
      bodyElement.style.width = "max(40%, 400px)";
    } else bodyElement.style.width = "100%";
  }
}
